import React from "react";
import DocumentUpload from "./DocumentUpload";

const AadhaarCardUpload = ({ cardDetails }) => {
  return (
    <DocumentUpload
      width={"60%"}
      cardDetails={cardDetails}
      documentType="identity_proof"
      documentSubType="aadhaar_card"
      documentNumber={null}
      documentIdentifier="Aadhaar Card"
      thumbnail={cardDetails?.file_url}
    />
  );
};

export default AadhaarCardUpload;
